var utils = require('../utils');

module.exports = {

  handleCharge: function(charge) {
    var credential = charge.credential[charge.channel];
    var request_url = credential.channelUrl;
    delete credential.channelUrl;

    utils.formSubmit(request_url, 'post', credential);
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/pingpp-js/src/channels/pab_pc.js
// module id = y0AO
// module chunks = 5